import React from "react";
import PlantSchematic from "./PlantSchematic";
import HomeScoreboard from "./HomeScoreboard";
import Reveal from "./Reveal";

export default function HomeTechnology() {
  return (
    <section
      id="system"
      className="scroll-mt-24 border-t border-gray-200 bg-white py-12 sm:py-14"
      aria-labelledby="tech-heading"
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,11fr)_minmax(0,9fr)] lg:gap-12">
          <Reveal className="w-full min-w-0 text-left">
            <h2 id="tech-heading" className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              The robot is not the solution. The system is.
            </h2>
            <p className="mt-6 text-base leading-relaxed text-gray-600 sm:text-lg">
              Different plants need different AMR and AGV hardware. Layout, constraints, and
              traffic come first. Vendors are chosen around that system.
            </p>
            <div className="mt-10">
              <HomeScoreboard compact />
            </div>
          </Reveal>

          <Reveal className="flex w-full min-w-0 items-center" delay={0.06}>
            <PlantSchematic />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
